import { ResponseRate } from 'model/ResponseRate';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'responseRate';

export namespace ResponseRateState {
  export type Domain = {
    data: Record<number, Resource<ResponseRate | null>>;
  };

  export const INITIAL_DOMAIN: Domain = { data: {} };
}
